module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_honor_magicbook_en-00b1156c252f8e29e5052d0f7075b5f2.png";